import React from 'react';
import {_Object} from "react-utils-y";

//公用获取主题的方法
let getTheme = (_this) => {
    // designationTheme  指定的主题，  theme  redux设置的全局主题,
    let themeName = _this.props.designationTheme || _this.props.theme || "default";
    //表单的类型， 如 ： 是带框类型的啊，  或者带线类型的啊
    let formType = _this.props.formType ? _this.props.formType + "_type" : "default_type";
    let _theme = _this.state.theme[themeName].form[formType];

    if (!_theme) {
        _theme = _this.state.theme["default"].form["default_type"];
    }
    return _theme
};

//公用设置样式
let setWidStyles = (_this, _styles, type)=> {
    let styles = Object.assign({}, _styles);

    let textWidth = _this.props.textWidth || "4rem";//8rem
    textWidth = textWidth && textWidth.indexOf('rem') >= 0 ? parseFloat(textWidth) : parseFloat(textWidth / 16);
    let valueWidth = _this.props.valueWidth || '14.375rem';
    valueWidth = valueWidth && valueWidth.indexOf('rem') >= 0 ? parseFloat(valueWidth) : parseFloat(valueWidth / 16);

    //设置表单的总宽度
    if (_this.props.formText) {
        styles.formBox.width = `${textWidth + valueWidth + 1.25}rem`;//1.25是校验*的宽度
    } else if (!_this.props.formText && _this.props.required) {
        styles.formBox.width = `${1.25 + valueWidth}rem`;
    } else {
        styles.formBox.width = `${valueWidth}rem`;
    }

    //表单textwidth
    styles.formText.width = _this.props.formText ? `${textWidth}rem` : `2rem`;

    if (_this.props.formType == "box") {
        //表单valuewidth
        styles.formVInput_box.width = `${valueWidth}rem`;

        //提示
        styles.inputHintText.width = `${valueWidth}rem`;
    } else {
        //表单valuewidth
        styles.formVInput_delfault.width = `${valueWidth}rem`;
        styles.formVInputFocus_delfault.width = `${valueWidth}rem`;
        styles.formVInputError_delfault.width = `${valueWidth}rem`;
        styles.formVInputDisabled_delfault.width = `${valueWidth}rem`;

        //提示
        styles.inputHintText.width = `${valueWidth}rem`;

        //报错提示
        styles.errorBox_delfault.width = `${valueWidth}rem`;
    }


    if (type == "textarea") {
        let maxHeight = _this.props.maxHeight || "600px";
        maxHeight = maxHeight && maxHeight.indexOf('rem') >= 0 ? parseFloat(maxHeight) : parseFloat(maxHeight) / 16;
        styles.textareaDis.maxHeight = maxHeight + "rem";
    }
    // this.props.maxHeight || "600px"
    return styles
};

//公用设置下拉位置
const setLocationFn = (_this, e)=> {
    let formBox = _this.refs.formBox;
    let marginTop = e.nativeEvent.clientY - e.nativeEvent.offsetY;
    let marginBottom = window.innerHeight - marginTop - formBox.offsetHeight;
    if (marginBottom > marginTop) {
        _this.setState({
            selLocationH: "bottom"
        })
    } else {
        if (marginBottom > 352) {
            _this.setState({
                selLocationH: "bottom"
            })
        } else {
            _this.setState({
                selLocationH: "top"
            })
        }
    }

    let marginLeft = e.nativeEvent.clientX - e.nativeEvent.offsetX;
    let marginRight = window.innerWidth - marginLeft - formBox.offsetWidth;
    if (marginRight > marginLeft) {
        _this.setState({
            selLocationW: "right"
        })
    } else {
        if (marginRight > 352) {
            _this.setState({
                selLocationW: "right"
            })
        } else {
            _this.setState({
                selLocationW: "left"
            })
        }
    }
};
//获取位置信息的样式名
const setLocationClass = (_this) => {
    let h = _this.state.selLocationH;
    let w = _this.state.selLocationW;
    let className = "selectListBox_b_r";
    if (h == "bottom" && w == "right") {
        className = "selectListBox_b_r";
    }
    if (h == "top" && w == "right") {
        className = "selectListBox_t_r";
    }
    if (h == "bottom" && w == "left") {
        className = "selectListBox_b_l";
    }
    if (h == "top" && w == "left") {
        className = "selectListBox_t_l";
    }
    return className
};

//defautl 和 box 类型
//表单公用文字描述
const defaultFormText = (_this, styles) => {
    return [
        _this.props.formText ?
            <div key={1} style={styles.formText}>
                <span style={ _this.props.disabled ? styles.formTextSpanDis : styles.formTextSpan}>
                    {_this.props.formText}
                </span>
            </div> : null,
        _this.props.formText && !_this.props.required ? <label key={2} style={styles.formRequired}></label> : null,
        _this.props.required ? (<label key={2} style={styles.formRequired}>*</label>) : (null),
        <span key={3} style={styles.formTextSpanLine}> </span>,
    ];
};

//表单公用报错 default
const defaultError = (verifyFlag, styles) => {
    return verifyFlag.errorState ?
        <div style={styles.errorBox_delfault}>
            <p style={styles.errorText}>{verifyFlag.errorText}</p>
        </div>
        : null
};

//表单公用报错 box
const boxError = (verifyFlag, styles) => {
    return verifyFlag.errorState ?
        <div style={styles.errorBox_box}>
            <p style={styles.errorText}>{verifyFlag.errorText}</p>
        </div>
        : null
};

/**
 * formType 是 default 类型
 * @param verifyFlag 校验返回值
 * @param formValueDom subpage传来
 */
const formContDefault = (_this, styles, verifyFlag, value, formValueDom, _theme) => {
    return <div style={styles.formCont_default}>
        {defaultFormText(_this, styles)}
        <div style={
            _this.state.focusState ? styles.formVInputFocus_delfault :
                verifyFlag.errorState ? styles.formVInputError_delfault :
                    _this.props.disabled ? styles.formVInputDisabled_delfault :
                        styles.formVInput_delfault
        }>
            {formValueDom(_this, styles, value, _theme)}
        </div>
    </div>
};
/**
 * formType 是 box 类型
 * @param verifyFlag 校验返回值
 * @param formValueDom subpage传来
 */
const formContBox = (_this, styles, verifyFlag, value, formValueDom, _theme) => {
    return <div style={
        _this.props.disabled ? styles.formContDiabled_box :
            _this.state.focusState ? styles.formContFocus_box : styles.formCont_box
    }>
        {defaultFormText(_this, styles)}
        <div style={styles.formVInput_box}>
            {formValueDom(_this, styles, value, _theme)}
        </div>
    </div>
};


//初始化渲染
const renderBox = (_this, styleFn, formTypeDom, verifyFn) => {
    let formType = _this.props.formType || "default";
    let _theme = getTheme(_this);
    let styles = _Object.merge({}, styleFn(_theme, _this));
    let resSetWidStyles = setWidStyles(_this, styles),
        resVerifyFn = verifyFn(_this);
    switch (formType) {
        case "default":
            return formTypeDom[`${formType}Dom`](_this, resSetWidStyles, resVerifyFn, _theme);
            break;
        case "box":
            return formTypeDom[`${formType}Dom`](_this, resSetWidStyles, resVerifyFn, _theme);
            break;
        default:
            return <div>没有对应formType为{_this.props.formType}的类型</div>
    }
};

export {
    renderBox,
    setLocationFn,
    setLocationClass,

    formContDefault,
    formContBox,


    setWidStyles,
    defaultFormText,
    defaultError,
    boxError,
    getTheme,

}